import { Subscription } from "rxjs";
import { StatisticsService } from "app/services/statistics.service";
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { IActiveUsersStats } from "app/models/statistics.model";

import { ActiveUsersPerDayComponent } from "../../active-users-per-day/active-users-per-day.component";
import { ActiveUsersPerHourComponent } from "../../active-users-per-hour/active-users-per-hour.component";
import {
  StatisticsExportSnapshot,
  StatisticsExportWidget,
  StatisticsKpi,
  StatisticsTabExportSource,
  StatisticsExportProgressCallback,
} from "app/services/statistics-export.models";

@Component({
    selector: "active-users-tab",
    templateUrl: "./active-users-tab.component.html",
    styleUrls: ["./active-users-tab.component.css"],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
    ActiveUsersPerDayComponent,
    ActiveUsersPerHourComponent
]
})
export class ActiveUsersTabComponent implements OnInit, OnDestroy, StatisticsTabExportSource {
  constructor(public statistics: StatisticsService) {}

  subscription: Subscription;
  activeUsersData: IActiveUsersStats;

  @ViewChild(ActiveUsersPerDayComponent) activeUsersPerDay: ActiveUsersPerDayComponent;
  @ViewChild(ActiveUsersPerHourComponent) activeUsersPerHour: ActiveUsersPerHourComponent;

  ngOnInit() {
    this.subscription = this.statistics.activeUsersStatistics$.subscribe(
      (res) => {
        this.activeUsersData = this.statistics.activeUsersStatistics = res;
        this.statistics.activeUsersTabDataLoaded = true;
      },
      (err) => {
        console.log(err);
        this.activeUsersData = this.statistics.activeUsersStatistics = { activeUsersByDays: [], activeUsersByHours: [] };
        this.statistics.activeUsersTabDataLoaded = true;
      }
    );
    this.statistics.fetchActiveUsersStats$.next();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async collectExportSnapshots(
    onProgress?: StatisticsExportProgressCallback
  ): Promise<StatisticsExportSnapshot[]> {
    const widgetEntries: Array<{ widget: StatisticsExportWidget | undefined; titleKey: string }> = [
      { widget: this.activeUsersPerDay, titleKey: 'ACTIVE_USERS_PER_DAY' },
      { widget: this.activeUsersPerHour, titleKey: 'ACTIVE_USERS_PER_HOUR' },
    ];
    const snapshots: StatisticsExportSnapshot[] = [];
    const total = widgetEntries.length;

    for (let index = 0; index < widgetEntries.length; index++) {
      const { widget, titleKey } = widgetEntries[index];
      if (!widget) {
        throw new Error(
          `PDF export failed: widget "${titleKey}" is not available (view not rendered yet)`
        );
      }
      onProgress?.({
        phase: 'capture',
        current: index + 1,
        total,
        messageKey: titleKey,
      });
      try {
        const snapshot = await widget.captureForExport();
        // A widget with no data for the selected range returns null — skip it
        // instead of failing the whole export.
        if (snapshot) {
          snapshots.push(snapshot);
        }
      } catch (err) {
        throw new Error(`PDF export failed while capturing "${titleKey}": ${err instanceof Error ? err.message : String(err)}`);
      }
    }
    return snapshots;
  }

  getExportKpis(): StatisticsKpi[] {
    return [];
  }

  restoreViewAfterExport(): void {
    // Vertical bar charts use off-screen PDF capture and are not modified during export.
  }
}
